<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.usuario"
        ref="RkmDataTable"
        sort-by="nome"
    >
        <template v-slot:cell(permissoes)="{item}">
            <div
                v-for="(permissao, i) in item.permissoes"
                :key="i"
            >
                {{ permissao }}
            </div>
        </template>

        <template v-slot:cell(actions)="{item}">
            <rkm-button
                @click="edit(item.id)"
                authorize="edit-web-service-usuario"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="destroy(item)"
                authorize="destroy-web-service-usuario"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {error, repository} from '@/mixins'

export default {
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('webService.usuario'),
        }
    },
    data: () => ({
        fields: [
            {key: 'nome', label: 'Nome', name: 'usuario.nome', searchable: true, sortable: true},
            {key: 'permissoes', label: 'Permissões'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        edit(id) {
            this.$router.push({name: 'web-service-usuario-edit', params: {id}})
        },
        destroy(item) {
            const destroy = () => this.repositories.usuario.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o usuário?', destroy, this.handleError)
        },
    },
    mixins: [error, repository],
}
</script>